// extracted by mini-css-extract-plugin
export default {"hideAnythingBeneath":"TimelineLeg-module__hideAnythingBeneath___bK2Ye","technicalStop":"TimelineLeg-module__technicalStop___s5Nn6"};